import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import SuccessAlert from './../child/Alert/SuccessAlert';
import DengerAlert from './../child/Alert/DengerAlert';

const ForgotPasswordLayer = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const domains = ["gmail.com", "yahoo.com", "outlook.com"];
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();


  const handleEmailChange = (e) => {
  const value = e.target.value;
  setEmail(value);
  localStorage.setItem("signinemail", value);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) {
    setErrors({ email: "Email is required" });
  } else if (!emailRegex.test(value)) {
    setErrors({ email: "Please enter a valid email address" });
  } else {
    setErrors({});
  }

  const atIndex = value.indexOf("@");
  if (atIndex !== -1) {
    const enteredDomain = value.slice(atIndex + 1).toLowerCase();
    const matched = domains.filter((domain) =>
      domain.toLowerCase().startsWith(enteredDomain)
    );
    setSuggestions(matched);
    setShowSuggestions(true);
  } else {
    setShowSuggestions(false);
  }
};
const handleSuggestionClick = (domain) => {
  const atIndex = email.indexOf("@");
  const localPart = email.slice(0, atIndex);
  const newEmail = `${localPart}@${domain}`;
  setEmail(newEmail);
  setSuggestions([]);
  setShowSuggestions(false);

  // ✅ Re-run validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!newEmail) {
    setErrors({ email: "Email is required" });
  } else if (!emailRegex.test(newEmail)) {
    setErrors({ email: "Please enter a valid email address" });
  } else {
    setErrors({});
  }
};

useEffect(() => {
      const savedEmail = localStorage.getItem("signinemail");
      console.log(savedEmail);
      if (savedEmail) {
        setEmail(savedEmail); // Set saved email to input field
      }

      const token = localStorage.getItem("authToken");
      if (token) {
        navigate("/dashboard"); // Redirect if already logged in
      }

      document.body.classList.add("signin-page");

      return () => {
        document.body.classList.remove("signin-page");
      };
    }, [navigate]);


  const validateInputs = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleForgotPass = async (e) => {
    e.preventDefault();
    if (!validateInputs()) return;

    setLoading(true);
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/forgotPassword`;

    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      console.log(data);
      if (!response.ok) {
          if (data.message === "User not found.") {
          setErrors((prev) => ({
            ...prev,
            email: "The email address appears to be incorrect. Please verify it.",
          }));
        }
        else 
        {
          
           setErrors((prev) => ({
            ...prev,
            email:"You've reached the maximum number of OTP resend attempts for today",
          }));
        }
      }
      else
      {
          localStorage.setItem("email", email);
          localStorage.setItem("otpStartTime", Date.now().toString());

          setSuccessMessage("An OTP has been sent to your email address");
          setTimeout(() => {
            setSuccessMessage("");
            navigate("/otpVerify");
          }, 3000);
      }
    } catch (error) {
      setErrorMessage(error.message);
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setLoading(false);
    }
  };
  const isFormValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  return (
    <section className="auth bg-base d-flex flex-wrap">
      {successMessage && <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />}
      {errorMessage && <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />}

      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src={`${process.env.REACT_APP_PUBLIC_UR}/assets/images/auth/forgotpassword.png`} alt="Auth" />
        </div>
      </div>

      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            {/* <img src={`${process.env.REACT_APP_PUBLIC_UR}/assets/images/logo.png`} alt="Logo" /> */}
            <h4 className="mb-12">Forgot Password</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Enter the email address associated with your account and we will send you a One Time Code to reset your password.
            </p>
          </div>

          <form onSubmit={handleForgotPass}>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
             <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Enter Email"
                autoComplete="email"
                maxLength="80"
                value={email}
                onChange={handleEmailChange}
                /*onChange={(e) => {
                  const value = e.target.value;
                  setEmail(value);
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!value) {
                    setErrors({ email: "Email is required" });
                  } else if (!emailRegex.test(value)) {
                    setErrors({ email: "Please enter a valid email address" });
                  } else {
                    setErrors({});
                  }
                }}*/
              />
              {showSuggestions && suggestions.length > 0 && (
              <ul className="suggestion-box bg-white border p-2 radius-8 mt-1 shadow-sm" style={{ listStyle: 'none', margin: 0 }}>
                {suggestions.map((domain, index) => (
                  <li
                    key={index}
                    className="px-2 py-1 hover:bg-neutral-100 cursor-pointer"
                    onClick={() => handleSuggestionClick(domain)}
                  >
                    {`${email.split("@")[0]}@${domain}`}
                  </li>
                ))}
              </ul>
            )}
            </div>
            {errors.email && <p className="text-danger mt-1">{errors.email}</p>}

            <Link to="/sign-in" className="text-primary-600 fw-medium" style={{ float: "right" }}>
              Back To Sign In
            </Link>

            <button
              type="submit"
              className="btn btn-primary btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={!isFormValid || loading} style={{fontSize:"18px"}}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ForgotPasswordLayer;
